import {ConfEnv} from "../../config/config";
import publicRequest from "../../Infra/http/public.request";

export const postUserRegistrationSimplified = async data => {
  const response = await publicRequest.post(ConfEnv.API_URL.URL_REGISTER_SIMPLIFIED, data);
  return response;
};
